import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  main: {
    paddingTop: 45,
    width: '100%',
  },
  content: {
    padding: 15,
  },
}));

export default useStyles;
